import { RoutePaths } from "constants/RoutePaths";

export const publicRoutes: string[] = [
    RoutePaths.LOGIN,
    RoutePaths.FORGOT_PASSWORD,
    RoutePaths.RESET_PASSWORD,
    RoutePaths.FINISH_REGISTRATION,
    RoutePaths.CONFIRM_EMAIL,
    RoutePaths.UNAUTHORIZED,
    RoutePaths.MFA
  ];